$(".add-template-elemen__create-default").on("click", function () {
	$(".add-template-element__step--1").removeClass("active");
	$(".add-template-element__step--create-default").addClass("active");
});

$(".add-template-elemen__create-set").on("click", function () {
	$(".add-template-element__step--1").removeClass("active");
	$(".add-template-element__step--create-set").addClass("active");
});
